import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaitodamantaxi() {



  const cardData = {
    keyword: " Mumbai to Daman Taxi ",


"headingDescription": "Royal Route Cab offers reliable and comfortable Mumbai to Daman taxi services, ensuring a smooth, safe, and refreshing coastal journey for families, couples, and weekend travelers. Daman is a peaceful seaside destination known for its clean beaches, Portuguese heritage, relaxed atmosphere, and budget-friendly getaway experience, making it one of the most popular short-trip routes from Mumbai. Our professional drivers and well-maintained vehicles ensure a stress-free travel experience throughout the journey. The Mumbai to Daman route covers approximately 165 to 180 km via NH48 and takes around 3.5 to 5 hours depending on traffic conditions, weekend rush, and road stoppages. We offer flexible booking options including one-way taxi, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for all types of travelers. With easy online booking and 24/7 customer support, Royal Route Cab is your trusted partner for Mumbai to Daman taxi travel.",

"topPlaces": [
  {
    "title": "Devka Beach",
    "description": "Devka Beach is one of the most popular attractions in Daman, known for its rocky shoreline, evening street food stalls, amusement rides, and lively sunset views. Unlike typical sandy beaches, Devka offers a dramatic coastal landscape where waves crash against rocks, creating a unique and scenic atmosphere. It is especially vibrant in the evening with families, tourists, and food vendors enjoying the seaside vibe."
  },
  {
    "title": "Jampore Beach",
    "description": "Jampore Beach is a calm and clean beach in Daman known for its blackish sand, shallow waters, and peaceful environment. It is ideal for swimming, horse riding, camel rides, and relaxing walks along the shore. Compared to Devka, Jampore is less crowded and more suitable for travelers seeking a quiet and laid-back beach experience."
  },
  {
    "title": "Daman Fort (St. Jerome Fort)",
    "description": "Daman Fort, also known as St. Jerome Fort, is a historic Portuguese-era structure overlooking the river and sea. It features massive stone walls, old gateways, and colonial architecture that reflects Daman’s rich history. Visitors can enjoy panoramic views of the coastline and explore the heritage charm of the old fort area."
  },
  {
    "title": "Bom Jesus Church (Daman)",
    "description": "Bom Jesus Church is one of the oldest churches in Daman, known for its beautiful colonial architecture, peaceful interiors, and religious significance. The church reflects Portuguese influence and is an important spiritual landmark for both locals and tourists exploring the cultural heritage of the region."
  },
  {
    "title": "Dominican Monastery Ruins",
    "description": "The Dominican Monastery Ruins are a historic site showcasing the remains of an old Portuguese monastery. The stone structures, arches, and weathered walls create a mystical and photogenic environment, making it a favorite spot for history lovers and photographers interested in colonial heritage."
  },
  {
    "title": "Moti Daman Jetty",
    "description": "Moti Daman Jetty is a scenic waterfront area where visitors can enjoy views of fishing boats, calm waters, and sunset reflections. It is a peaceful spot ideal for evening walks and photography, offering a glimpse into the daily life of local fishermen and coastal culture."
  },
  {
    "title": "Light House Daman",
    "description": "The Daman Lighthouse offers panoramic views of the Arabian Sea, river estuary, and surrounding coastline. Visitors can climb up to enjoy breathtaking sunset views, making it one of the best viewpoints in the region for photography and relaxation."
  },
  {
    "title": "Mirasol Lake Garden",
    "description": "Mirasol Lake Garden is a well-maintained recreational park featuring a large artificial lake, boating facilities, gardens, and entertainment zones. It is a family-friendly attraction where visitors can enjoy boating, toy train rides, and peaceful leisure time in a green environment."
  },
  {
    "title": "Church of Our Lady of the Sea",
    "description": "This beautiful church is located near the coastline and is known for its serene atmosphere and historical significance. It provides a peaceful space for prayer and reflection while showcasing colonial-era architecture and coastal charm."
  },
  {
    "title": "Vanganga Lake Garden (Nearby Dadra)",
    "description": "Located near Daman in Dadra and Nagar Haveli, Vanganga Lake Garden is a beautifully landscaped park with walking paths, flower gardens, and boating options. It is a perfect extension for travelers exploring Daman, offering a calm and scenic nature experience."
  }
],






services: [
  {
    name: "Mumbai to Daman Taxi",
    description: "Mumbai to Daman taxi service offers a smooth and relaxing coastal journey to one of the most popular beach destinations near Mumbai. The route is known for scenic views, greenery, and easy highway travel. Ideal for weekend getaways, families, couples, and group trips, this service ensures safe and comfortable travel. Professional drivers and clean vehicles enhance the experience. Multiple car options are available. It guarantees a refreshing and hassle-free trip."
  },
  {
    name: "Mumbai to Daman Cab",
    description: "Mumbai to Daman cab provides convenient and private transportation with door-to-door pickup and drop. This service is perfect for travelers seeking a comfortable ride to the beach destination. Vehicles are well-maintained and driven by experienced chauffeurs. Suitable for short vacations and leisure trips. It ensures a smooth and enjoyable journey."
  },
  {
    name: "Mumbai to Daman Cab Service",
    description: "Mumbai to Daman cab service is designed for quick and reliable travel with a focus on comfort and safety. The route offers beautiful coastal surroundings and smooth highways. This service is ideal for families, couples, and group travel. Vehicles are maintained for performance. It ensures a dependable journey."
  },
  {
    name: "Mumbai to Daman Taxi Service",
    description: "Mumbai to Daman taxi service offers dependable transportation for travelers heading to this coastal destination. Clean vehicles and trained drivers ensure a comfortable ride. Flexible scheduling allows easy trip planning. Door-to-door service adds convenience. It guarantees a stress-free travel experience."
  },
  {
    name: "Cab from Mumbai to Daman",
    description: "Cab from Mumbai to Daman provides a personalized travel experience with flexible stops along the route. Travelers can enjoy scenic coastal views during the journey. This service is ideal for families and small groups. Professional drivers ensure safe travel. It offers a relaxed road trip experience."
  },
  {
    name: "Taxi from Mumbai to Daman",
    description: "Taxi from Mumbai to Daman offers a convenient and efficient way to travel between the two destinations. With experienced drivers and comfortable vehicles, the journey is smooth and enjoyable. Door-to-door pickup adds convenience. Suitable for weekend trips and short vacations. It ensures a reliable journey."
  },
  {
    name: "Mumbai to Daman Cab Booking",
    description: "Mumbai to Daman cab booking allows travelers to reserve their ride easily with flexible options. Customers can choose vehicle type, pickup location, and timing. Instant confirmation and transparent pricing ensure a hassle-free process. It simplifies travel planning."
  },
  {
    name: "Mumbai to Daman Taxi Booking Online",
    description: "Mumbai to Daman taxi booking online provides a quick and convenient way to plan your journey. Customers can compare vehicle options and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures availability during peak travel times."
  },
  {
    name: "Mumbai to Daman Cab Price",
    description: "Mumbai to Daman cab price varies based on vehicle type, travel timing, and trip type. Transparent pricing ensures no hidden charges. Budget-friendly sedan options and premium SUVs are available. It helps travelers plan their trip efficiently. It ensures value for money."
  },
  {
    name: "Mumbai to Daman Taxi Fare",
    description: "Mumbai to Daman taxi fare is designed to be affordable and competitive for coastal travel. Fare depends on vehicle type and travel plan. Customers receive clear pricing details before booking. Multiple options suit different budgets. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Daman One Way Cab",
    description: "Mumbai to Daman one way cab is a cost-effective option for travelers needing a single-side drop. This service eliminates return charges and offers flexible travel timings. Ideal for quick getaways. Comfortable vehicles ensure a smooth ride. It is perfect for budget travel."
  },
  {
    name: "Mumbai to Daman Round Trip Taxi",
    description: "Mumbai to Daman round trip taxi is ideal for travelers planning a same-day or weekend return trip. This package includes pickup, drop, waiting time, and return travel. Flexible schedules make it convenient. Suitable for family outings and sightseeing. It ensures comfort and efficiency."
  },
  {
    name: "Mumbai to Daman Innova Cab",
    description: "Mumbai to Daman Innova cab is perfect for families and groups seeking spacious and comfortable travel. The vehicle offers ample seating and luggage space. Ideal for group trips. Professional drivers ensure safety. It provides a premium travel experience."
  },
  {
    name: "Mumbai to Daman Ertiga Cab",
    description: "Mumbai to Daman Ertiga cab is suitable for small groups and families looking for an affordable yet spacious ride. This vehicle offers comfortable seating and good mileage. It is ideal for budget-friendly travel. Drivers ensure smooth journeys. It ensures a pleasant experience."
  },
  {
    name: "Mumbai to Daman Sedan Cab",
    description: "Mumbai to Daman sedan cab is ideal for couples and small families seeking economical travel. Sedans offer smooth driving and comfort for short-distance trips. This option is widely preferred for its affordability. Professional drivers ensure safe travel. It is perfect for a quick journey."
  },
  {
    name: "Mumbai to Daman SUV Taxi",
    description: "Mumbai to Daman SUV taxi provides extra space and comfort for group travel. SUVs offer better stability and performance on highways. This option is ideal for families and corporate groups. Drivers ensure safe and reliable travel. It delivers a comfortable experience."
  },
  {
    name: "Cheap Mumbai to Daman Cab",
    description: "Cheap Mumbai to Daman cab offers budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers. Economical sedan options help reduce travel costs. Transparent pricing ensures no hidden charges. It is perfect for affordable trips."
  },
  {
    name: "Best Mumbai to Daman Taxi Service",
    description: "Best Mumbai to Daman taxi service ensures a premium travel experience with top-quality vehicles and professional drivers. This service focuses on punctuality, safety, and customer satisfaction. Multiple vehicle options are available for different needs. Transparent pricing builds trust. It guarantees a reliable and comfortable journey."
  }
],

tableData: [
  ["Mumbai to Daman Taxi", "Mumbai to Daman Cab"],
  ["Mumbai to Daman Cab Service", "Mumbai to Daman Taxi Service"],
  ["Cab from Mumbai to Daman", "Taxi from Mumbai to Daman"],
  ["Mumbai to Daman Cab Booking", "Mumbai to Daman Taxi Booking Online"],
  ["Mumbai to Daman Cab Price", "Mumbai to Daman Taxi Fare"],
  ["Mumbai to Daman One Way Cab", "Mumbai to Daman Round Trip Taxi"],
  ["Mumbai to Daman Innova Cab", "Mumbai to Daman Ertiga Cab"],
  ["Mumbai to Daman Sedan Cab", "Mumbai to Daman SUV Taxi"],
  ["Cheap Mumbai to Daman Cab", "Best Mumbai to Daman Taxi Service"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Daman Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Mumbai to Daman taxi service, perfect for beach trips, weekend getaways, and family outings."
  },
  {
    WhyChooseheading: "Experienced Coastal Route Drivers",
    WhyChoosedescription: "Our drivers are well-trained on Mumbai to Daman routes, ensuring safe driving and smooth navigation along highways and coastal roads."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Taxi Service Availability",
    WhyChoosedescription: "Our Mumbai to Daman taxi service operates 24/7, allowing flexible travel anytime as per your convenience."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned to ensure a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way taxi service, round-trip bookings, or same-day return options for Daman trips."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for individuals and group travel."
  },
  {
    WhyChooseheading: "Trusted Weekend Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Mumbai to Daman taxi bookings due to punctual service, professional drivers, and reliable experience."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Daman taxi service?", answer: "Yes, Royal Route Cabs offers reliable taxi services from Mumbai to Daman for both one-way and round trips." },
  { question: "What is the distance between Mumbai and Daman?", answer: "The distance is approximately 170 to 190 km and takes around 3.5 to 5 hours depending on traffic and route." },
  { question: "Is taxi service available 24 hours?", answer: "Yes, our Mumbai to Daman taxi service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way taxi?", answer: "Yes, we provide both one-way and round-trip taxi services." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we offer pickup from home, hotel, and airport anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended, especially during weekends and peak travel seasons." },
  { question: "Do you provide same-day return trips?", answer: "Yes, we offer same-day return taxi services for Mumbai to Daman trips." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vikram Shah",
    feedback: "The Mumbai to Daman taxi service with Royal Route Cabs was very smooth and comfortable. The coastal drive was enjoyable and the journey felt safe throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Patel",
    feedback: "Excellent experience traveling from Mumbai to Daman. The cab was clean, the driver was professional, and the overall ride was relaxing and hassle-free.",
    rating: 5
  }
];


















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Daman Taxi",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-daman-cab.jpg", // replace if needed
  "description": "Book Mumbai to Daman taxi with Royal Route Cabs for a safe, comfortable, and affordable coastal journey. Choose from sedan, SUV, Innova, and luxury cars for one-way and round-trip travel with 24x7 reliable service and experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4000", // adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-daman-cab"
  }
};






  return (
    <div>

<Helmet>
  <title>Mumbai to Daman Taxi | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Daman taxi at best price with Royal Route Cabs. One-way & round-trip cab service with sedan, SUV, Innova & luxury cars. Safe, reliable & 24x7 available."
  />

  <meta
    name="keywords"
    content="mumbai to daman taxi, mumbai to daman cab, mumbai to daman cab service, mumbai to daman taxi service, cab from mumbai to daman, taxi from mumbai to daman, mumbai to daman cab booking, mumbai to daman taxi booking online, mumbai to daman cab price, mumbai to daman taxi fare, mumbai to daman one way cab, mumbai to daman round trip taxi, mumbai to daman innova cab, mumbai to daman ertiga cab, mumbai to daman sedan cab, mumbai to daman suv taxi, cheap mumbai to daman cab, best mumbai to daman taxi service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/93.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitodamantaxi;